<template>
  <div class="myPromotion-container">
    <el-card shadow="never">
       <mer-search :searchConfig="formConfig"
        :searchBar="searchBar" 
        @search="searchData" 
        @reset="resetData" 
        @changeTime="(value,model)=>changeTime(value, 'searchBar', 'startCreateTime', 'endCreateTime')"
        :loading="tableLoading" :isLayout="true"
      >
      <template slot="activeType">
        <el-select v-model="searchBar.activityType" placeholder="全部">
          <el-option v-for="item in activeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </template>
      </mer-search>
    </el-card>
    <el-card shadow="never" style="margin-top: 20px">
      <mer-table :loading="tableLoading" 
        :tableConfig="tableConfigDay" 
        :tableData="tableData" 
        :pagination="pagination" 
        @SizeChange="handleSizeChange" 
        @PageChange="pageChange"
        :hasIndex="true">
        <template slot="action" slot-scope="{row}">
          <div>
            <el-button type="text"
            @click="goDetail(row)">详情</el-button>
            <el-button v-if="row.agreeButton" type="text" @click="handleModel('agree', row)">同意</el-button>
            <el-button v-if="row.rejectButton" type="text" @click="handleModel('refused', row)">驳回</el-button>
            <el-button v-if="row.withdrawalButton" type="text" @click="handleModel('withdraw', row)">撤回</el-button>
            <el-button v-if="row.rejoinButton" type="text" @click="handleSign(row)">再次报名</el-button>
          </div>
        </template>
      </mer-table>
    </el-card>
    <actionModel ref="actionModel" @actionModel="actionModel"/>
  </div>
</template>
<script>
import mixinBtn from './myProComponents/mixinBtn'
import actionModel from './myProComponents/actionModel'
import listPage from '@/mixins/listPage'
import { getActiveList, checkList, getActivityTypeList } from '@/api/marketPromotion'
import { alertType } from '@/api/vipMarket'
let formConfig = [
  {label: '审核类型', type:'slot', slotName: 'activeType'},
  {label: '创建时间',type: 'date',modelName: 'invoiceTime',model: '',dateType: 'datetimerange',format: 'yyyy-MM-dd HH:mm:ss',pickerOptions:{}, clearable:false},
  {label: '审核状态',type: 'select',modelName: 'activityStatus',placeholder: '全部',selectOptions: [],define: true,selectLabel: 'label',selectValue: 'value'}
]

let tableConfigDay = [
  // {label: '活动类型',prop: 'activityTypeDesc' },
  // {label: '序号',prop: 'activityId'},
  {label: '审核类型',prop: 'activityTypeDesc' },
  {label: '审核状态',prop: 'approvalStatus' },
  {label: '创建人',prop: 'createUser'},
  {label: '创建时间',prop: 'createTime'},
  {label: '操作',slot:'action', width: 150, fixed: 'right'}
]

export default {
  // name: 'myPromotion',
  mixins: [mixinBtn, listPage],
  data () {
    return {
      isNewMessage: false,
      searchBar: {
        activityType: null //  7-天天特价 8-送水 9-限时秒杀 10-精准营销 11-抽奖宝
      },
      isSendWater: true, // 判断是送水还是其他的需求
      activeList: [],
      formConfig,
      tableConfigDay
    }
  },
  components: {
    actionModel
  },
  created () {
    this.searchBar.activityType = this.$route.query.id ? Number(this.$route.query.id) : null
    this.getActiveList()
    this.getActivityTypeListApi()
    this.refresh()
    this.$track.pageViewEvent('审核中心', '1628236409')
  },
  methods: {
    // 覆写列表请求接口
    async refresh () {
      this.tableLoading = true
      const data = { ...this.searchBar, ...this.pagination}
      //对查询条件做一次缓存
      this.downloadParams = { ...this.searchBar }
      try{
        // 如果活动类型是 7-限时秒杀，8-送水,9-天天特价
        const { code, result = [], totalRow = 0 } = await checkList(data)
        if(code !== 200) return
        this.tableData.records = result
        this.tableData.total = parseInt(totalRow)
      }catch(err){
        console.log(err)
      }finally{
        this.tableLoading = false
      }
    },
    goDetail (row) {
      this.$track.clickEvent('审核中心-审核列表-操作类型', '1628236483', {tysj_trade_type:1})
      this.$router.push({ name: 'myProDetail', params: { activityId: row.activityId, row: JSON.stringify(row) } })
    },
    searchData () {
      this.search()
      const { activityStatus, activityType, endCreateTime, startCreateTime } = this.searchBar
      if (activityStatus) this.$track.clickEvent('审核中心-审核列表-申请状态', '1628236467', { tysj_trade_type: activityStatus })
      if (activityType) this.$track.clickEvent('审核中心-审核列表-审核类型', '1628236466', { tysj_trade_type: activityType })
      if (endCreateTime) this.$track.clickEvent('审核中心-创建时间选择', '1628236457', { tysj_start_time: startCreateTime, tysj_end_time: endCreateTime })
      this.$track.clickEvent('审核中心-审核列表-查询', '1628236468')
    },
    resetData () {
      this.reset(this.initQuery)
      this.$track.clickEvent('审核中心-审核列表-重置', '1628236469')
    },
    // 操作按钮点击以后处理-子组件
    actionModel () {
      this.refresh()
    },
    // 操作不同按钮，调取不同接口
    async handleModel (btnType, row) {
      let type = 0
      switch (btnType) {
        case 'agree':
          type == 2
          break;
        case 'refused':
          type == 3
          break;
        case 'withdraw':
          type == 5
          break;
      }
      this.$track.clickEvent('审核中心-审核列表-操作类型', '1628236483', { tysj_trade_type: type })
      // 精准营销，同时又是同意按钮，就要判断文案展示
      if (row.activityType === 10 && btnType === 'agree') {
        const { result } = await alertType({ activityType: row.activityType, activityId: row.activityId })
        let tip = ''
        const router = null
        const perTip = result.message
        this.$refs.actionModel.init(btnType, row, router, tip, perTip)
      } else {
        const router = null
        this.$refs.actionModel.init(btnType, row, router, row.activityTypeDesc)
      }
    },
    // 再次报名,只有天天特价，限时秒杀有再次报名
    handleSign (row) {
      switch (row.activityType) {
        case 7:
          this.$track.clickEvent('审核中心-审核列表-再次报名', '1632832581', { tysj_trade_type: 0 })
          this.$router.push({ path: '/promotion/daySpecialSign', id: row.activityId })
          break
        case 9:
          this.$track.clickEvent('审核中心-审核列表-再次报名', '1632832581', { tysj_trade_type: 1 })
          this.$router.push({ path: '/promotion/limitShopSign', id: row.activityId })
          break
        case 10:
          this.$track.clickEvent('审核中心-审核列表-再次报名', '1632832581', { tysj_trade_type: 5 })
          this.$router.push({ path: '/vipMarket/vipDraw' })
      }
    },
    // 获取状态接口
    async getActiveList () {
      try {
        const { code, result } = await getActiveList()
        if (code !== 200) return
        const initObj = { activityStatus: Object.entries(result).map(item => ({ label: item[1], value: Number(item[0]) })) }
        this.setSearchConfig(initObj)
      } catch (error) {
        console.log(error)
      }
    },
    // 互动列表枚举接口
    async  getActivityTypeListApi () {
      try {
        const { code, result } = await getActivityTypeList()
        if (code !== 200) return
        this.activeList = result
      } catch (error) {
        console.log(error)
      }
    },
    initQuery () {
      this.formConfig[this.findConfigIndex(this.formConfig, 'invoiceTime')].model = ''
      this.searchBar.startCreateTime = ''
      this.searchBar.endCreateTime = ''
    }
  }
}
</script>
<style lang="less" scoped>
  .myPromotion-container {
    padding-top: 35px;
  }
</style>